const configurationApi = require('../api/configuration');
const { fetchCountryIfNeeded } = require('./CountryActions');

const MIN_CONFIGURATION_UPDATE = 1000 * 60 * 15;
const FETCH_CONFIGURATION_TIMEOUT = 1000 * 30;

function fetchConfigurationInProgress(fetchPromise) {
  return {
    type: 'FETCH_CONFIGURATION_IN_PROGRESS',
    timestamp: Date.now(),
    fetchPromise,
  };
}

function fetchConfigurationSuccessful(data) {
  return {
    type: 'FETCH_CONFIGURATION_SUCCESSFUL',
    data,
    timestamp: Date.now(),
  };
}

function fetchConfigurationFailed(reason) {
  return {
    type: 'FETCH_CONFIGURATION_FAILED',
    reason,
    timestamp: Date.now(),
  };
}

function fetchConfiguration() {
  return async (dispatch, getState) => {
    const fetchPromise = (async () => {
      try {
        const country = await dispatch(fetchCountryIfNeeded());
        const state = getState();
        const { apiUrl } = state.auth;
        const configuration = await configurationApi.fetchConfiguration(
          apiUrl,
          country,
        );
        const data = (configuration && configuration.data) || {};
        dispatch(fetchConfigurationSuccessful(data));
        return data;
      } catch (error) {
        dispatch(fetchConfigurationFailed(error));
        throw error;
      }
    })();

    dispatch(fetchConfigurationInProgress(fetchPromise));
    return fetchPromise;
  };
}

function shouldFetchConfiguration(state, skipOutdatedCheck) {
  const { fetchingInProgressSince, didInvalidate, lastSuccessfulFetch } =
    state.configuration;

  if (!fetchingInProgressSince) {
    // Should update if it was explicetely invalidated
    if (didInvalidate) {
      return true;
    }

    // Should update if data is too old
    if (
      !skipOutdatedCheck &&
      (!lastSuccessfulFetch ||
        Date.now() - lastSuccessfulFetch > MIN_CONFIGURATION_UPDATE)
    ) {
      return true;
    }
  } else if (
    fetchingInProgressSince &&
    Date.now() - fetchingInProgressSince > FETCH_CONFIGURATION_TIMEOUT
  ) {
    // Ensure we cannot get stuck in fetchingInProgressSince=true state.
    return true;
  }

  return false;
}

function fetchConfigurationIfNeeded() {
  return async (dispatch, getState) => {
    const state = getState();
    if (shouldFetchConfiguration(state)) {
      return dispatch(fetchConfiguration());
    }
    const { fetchPromise, data } = state.configuration;
    return fetchPromise && fetchPromise.then ? fetchPromise : data;
  };
}

module.exports = {
  fetchConfiguration,
  fetchConfigurationIfNeeded,
};
